// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Gambarino-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Gambarino-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/Geist-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/Geist-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Gambarino';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Geist';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
         url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
    font-weight: 200;
    font-style: normal;
}

.hiw4 {
  position: relative;
  isolation: isolate;

  /* shared text-panel height (tweak this until it feels perfect) */
  --hiw4-textH: clamp(120px, 18vh, 240px);
}

.hiw4__sticky {
  position: sticky;
  top: 0;
  height: 100vh;
  overflow: hidden;
}

.hiw4__stage {
  position: relative;
  width: 100%;
  height: 100%;
}

/* text columns */
.hiw4__left,
.hiw4__right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  width: min(34vw, 520px);
  height: var(--hiw4-textH);       /* ✅ equal heights */
  display: flex;                   /* ✅ center content inside */
  align-items: center;             /* ✅ vertical centering within the panel */
  z-index: 40;

  color: rgba(252, 249, 248, 1);
  pointer-events: none;
}

.hiw4__left {
  left: clamp(12px, 2vw, 40px);
  font-family: Gambarino;
}

.hiw4__right {
  right: clamp(12px, 2vw, 40px);
  text-align: right;
  font-family: Geist;
}

.hiw4__kicker {
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-weight: 700;
  letter-spacing: 0.12em;
  font-size: 12px;
  opacity: 0.75;
  margin-bottom: 18px;
}

.hiw4__subtitle {
  font-family: Gambarino, Geist, Helvetica, Arial, sans-serif;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 0.95;
  font-size: clamp(44px, 4.6vw, 96px);
  color: #5FBA8B;
}

.hiw4__body {
  font-family: Geist, Helvetica, Arial, sans-serif;
  font-weight: 300;
  line-height: 1.5;
  font-size: clamp(16px, 1.25vw, 22px);
  color: rgba(252, 249, 248, 0.88);
  max-width: 46ch;
}

.hiw4__canvas{
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
}

/* Laptop wrap stays centered */
.hiw4__laptopWrap {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  z-index: 20;
}

.hiw4__laptopBox {
  position: relative;

  /* target height */
  height: 90vh;

  /* keep 16:9 */
  width: calc(90vh * (16 / 9));
  aspect-ratio: 16 / 9;

  /* don't exceed viewport width */
  max-width: 92vw;

  background: transparent;
  border-radius: 0;
  overflow: visible;
}

.hiw4__vid {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
  transition: opacity 120ms linear;
}

.hiw4__wash {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0);
  mix-blend-mode: screen;
  pointer-events: none;
}

/* Mobile: stack text */
@media (max-width: 900px) {
  .hiw4__left,
  .hiw4__right {
    left: 50%;
    right: auto;
    width: calc(100% - 44px);
    max-width: 640px;
    transform: translate(-50%, -50%);
  }
  .hiw4__left { top: 18%; }
  .hiw4__right { top: 84%; }
  .hiw4__laptopBox { width: calc(100% - 44px); border-radius: 18px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/howitworks_v4.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB;8DAC+D;IAC/D,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB;mEACgE;IAChE,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;;EAElB,iEAAiE;EACjE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA,iBAAiB;AACjB;;EAEE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;;EAE3B,uBAAuB;EACvB,yBAAyB,QAAQ,oBAAoB;EACrD,aAAa,oBAAoB,4BAA4B;EAC7D,mBAAmB,cAAc,0CAA0C;EAC3E,WAAW;;EAEX,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2DAA2D;EAC3D,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,kBAAkB;;EAElB,kBAAkB;EAClB,YAAY;;EAEZ,cAAc;EACd,4BAA4B;EAC5B,oBAAoB;;EAEpB,gCAAgC;EAChC,eAAe;;EAEf,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE;;IAEE,SAAS;IACT,WAAW;IACX,wBAAwB;IACxB,gBAAgB;IAChB,gCAAgC;EAClC;EACA,cAAc,QAAQ,EAAE;EACxB,eAAe,QAAQ,EAAE;EACzB,mBAAmB,wBAAwB,EAAE,mBAAmB,EAAE;AACpE","sourcesContent":["@font-face {\n    font-family: 'Gambarino';\n    src: url('../assets/fonts/Gambarino-Regular.woff2') format('woff2'),\n    url('../assets/fonts/Gambarino-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Geist';\n    src: url('../assets/fonts/Geist-Regular.woff2') format('woff2'),\n         url('../assets/fonts/Geist-Regular.ttf') format('truetype');\n    font-weight: 200;\n    font-style: normal;\n}\n\n.hiw4 {\n  position: relative;\n  isolation: isolate;\n\n  /* shared text-panel height (tweak this until it feels perfect) */\n  --hiw4-textH: clamp(120px, 18vh, 240px);\n}\n\n.hiw4__sticky {\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.hiw4__stage {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n/* text columns */\n.hiw4__left,\n.hiw4__right {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n\n  width: min(34vw, 520px);\n  height: var(--hiw4-textH);       /* ✅ equal heights */\n  display: flex;                   /* ✅ center content inside */\n  align-items: center;             /* ✅ vertical centering within the panel */\n  z-index: 40;\n\n  color: rgba(252, 249, 248, 1);\n  pointer-events: none;\n}\n\n.hiw4__left {\n  left: clamp(12px, 2vw, 40px);\n  font-family: Gambarino;\n}\n\n.hiw4__right {\n  right: clamp(12px, 2vw, 40px);\n  text-align: right;\n  font-family: Geist;\n}\n\n.hiw4__kicker {\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  font-size: 12px;\n  opacity: 0.75;\n  margin-bottom: 18px;\n}\n\n.hiw4__subtitle {\n  font-family: Gambarino, Geist, Helvetica, Arial, sans-serif;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 0.95;\n  font-size: clamp(44px, 4.6vw, 96px);\n  color: #5FBA8B;\n}\n\n.hiw4__body {\n  font-family: Geist, Helvetica, Arial, sans-serif;\n  font-weight: 300;\n  line-height: 1.5;\n  font-size: clamp(16px, 1.25vw, 22px);\n  color: rgba(252, 249, 248, 0.88);\n  max-width: 46ch;\n}\n\n.hiw4__canvas{\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n/* Laptop wrap stays centered */\n.hiw4__laptopWrap {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate3d(-50%, -50%, 0);\n  z-index: 20;\n}\n\n.hiw4__laptopBox {\n  position: relative;\n\n  /* target height */\n  height: 90vh;\n\n  /* keep 16:9 */\n  width: calc(90vh * (16 / 9));\n  aspect-ratio: 16 / 9;\n\n  /* don't exceed viewport width */\n  max-width: 92vw;\n\n  background: transparent;\n  border-radius: 0;\n  overflow: visible;\n}\n\n.hiw4__vid {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  user-select: none;\n  pointer-events: none;\n  transition: opacity 120ms linear;\n}\n\n.hiw4__wash {\n  position: absolute;\n  inset: 0;\n  background: rgba(255, 255, 255, 0);\n  mix-blend-mode: screen;\n  pointer-events: none;\n}\n\n/* Mobile: stack text */\n@media (max-width: 900px) {\n  .hiw4__left,\n  .hiw4__right {\n    left: 50%;\n    right: auto;\n    width: calc(100% - 44px);\n    max-width: 640px;\n    transform: translate(-50%, -50%);\n  }\n  .hiw4__left { top: 18%; }\n  .hiw4__right { top: 84%; }\n  .hiw4__laptopBox { width: calc(100% - 44px); border-radius: 18px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
